<template>
    <b-input 
        class="interior-search-input is-hidden-touch" 
        type="text" 
        icon="search"
        icon-pack="fas" 
        :value="value" 
        @input="handleInput" 
        @keyup.enter.native="handleSearch" 
        @keydown.down.prevent.native="moveDown"
        @keydown.up.prevent.native="moveUp" 
        ref="input" 
        placeholder=""
    />
</template>

<script>
export default {
    name: 'DesktopSearchInput',
    props: {
        value: {
            type: String,
            required: true
        }
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value)
        },
        handleSearch() {
            this.$emit('search')
        },
        moveDown() {
            this.$emit('move-down')
        },
        moveUp() {
            this.$emit('move-up')
        }
    }
}
</script> 